<script lang="ts">
  import type {Question, CurrentResponses, QuestionOnChange} from '../types';
  import {createEventDispatcher} from 'svelte';
  import {getDisplayValue} from '../utils';
  import Markdown from '../Markdown.svelte';

  export let question: Question;
  export let pageQuestionIdx: string;
  export let validations: string | null = null;
  export let currentResponses: CurrentResponses;

  import MultipleChoiceQuestion from './MultipleChoice.svelte';
  import TextBlock from './TextBlock.svelte';
  import CheckboxQuestion from './CheckboxQuestion.svelte';
  import FillInTheBlank from './FillInTheBlank.svelte';
  import MatrixQuestion from './MatrixQuestion.svelte';
  import TextInput from './TextInput.svelte';
  import LanguagesExampleWidget from './LanguagesExampleWidget.svelte';
  const dispatch = createEventDispatcher();

  let onChange: QuestionOnChange = ({newValue, altId, noEventLog}) => {
    dispatch('change', {questionId: altId || pageQuestionIdx, newValue, noEventLog: !!noEventLog});
  };
  $: label = getDisplayValue<any>(currentResponses, question, 'label');
  $: isRequired = question.requireResponse;
</script>

<div class="mb-8">
  {#if question.type !== 'text-block'}
    <Markdown
      text={`${label}${isRequired ? '<span style="color: salmon">*</span> ' : ''}`}
      shadowLineBreaks={true}
    />
  {/if}
  <div class="my-2 flex flex-col">
    {#if question.type === 'multiple-choice'}
      <MultipleChoiceQuestion bind:question {pageQuestionIdx} {onChange} {currentResponses} />
    {:else if question.type === 'checkbox-question'}
      <CheckboxQuestion bind:question {pageQuestionIdx} {onChange} {currentResponses} />
    {:else if question.type === 'fill-in-the-blank-list'}
      <FillInTheBlank bind:question {pageQuestionIdx} {onChange} {currentResponses} />
    {:else if question.type === 'matrix-question'}
      <MatrixQuestion bind:question {pageQuestionIdx} {onChange} {currentResponses} />
    {:else if question.type === 'text-block'}
      <TextBlock bind:question {currentResponses} />
    {:else if question.type === 'text-input'}
      <TextInput bind:question {pageQuestionIdx} {currentResponses} {onChange} />
    {:else if question.type === 'language-example-widget'}
      <LanguagesExampleWidget />
    {:else}
      <div>no question of that type</div>
    {/if}
    {#if validations}
      <div class="text-red-600">{validations}</div>
    {/if}
  </div>
</div>
